import React from "react";
// import WarningIcon from '@material-ui/icons/Warning';
import moment from 'moment'
import CircularProgress from '@material-ui/core/CircularProgress'
import jsPDF from 'jspdf'
import { Helmet } from "react-helmet";
import { TextField } from '@material-ui/core';
import Chip from '@material-ui/core/Chip';
// import Tooltip from '@material-ui/core/Tooltip';
import MuiAlert from '@material-ui/lab/Alert';
import Snackbar from '@material-ui/core/Snackbar';
import Tabs from '@material-ui/core/Tabs';
import k1 from 'assets/img/kj.png';
import k3 from 'assets/img/kj3.png';
import Tab from '@material-ui/core/Tab';
import Paper from '@material-ui/core/Paper';
import { red } from '@material-ui/core/colors';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import { } from "pages/redux/actions";
import axios from 'axios';
import logo from 'assets/img/ld.gif';
import logo2 from 'assets/img/noimage1.jpg';
import Avatar from '@material-ui/core/Avatar';
import { connect } from 'react-redux';
import { Link, useHistory } from "react-router-dom";
import { Button, Card, CardHeader, CardFooter, CardBody, FormGroup, Form, Container, Row,Modal,Input, Col,} from "reactstrap";
import UserHeader from "components/Headers/UserHeader.js";


import { createMuiTheme, MuiThemeProvider } from "@material-ui/core/styles";

import MUIDataTable from "mui-datatables";

const getMuiTheme = () =>
    createMuiTheme({
        overrides: {
            MuiTextField: {
                root: {
                    backgroundColor: '#fff',
                    width: '100%',
                    borderRadius: '5px',
                    border: '0px',
                    '&:hover': {
                        outline: '0',
                    },
                    '& label.Mui-focused': {
                        color: '#7c8892',
                    },
                    '& .MuiInput-underline:after': {
                        borderBottomColor: '#7c8892',
                    },
                    '& .MuiOutlinedInput-root': {
                        height: '45px',
                        '& fieldset': {
                            borderColor: '#e8ecef',
                            borderRadius: '5px',
                            border: '1px',
                            paddingTop: '0px',
                            boxShadow: '0 1px 3px rgba(50, 50, 93, 0.15), 0 1px 0 rgba(0, 0, 0, 0.02)',
                        },
                        '&:hover fieldset': {
                            borderColor: '#Dbe0e5',
                            border: '1px',
                        },
                        '&.Mui-focused fieldset': {
                            borderColor: '#',
                            border: '1px',
                            boxShadow: '0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08)',
                        },
                    },
                    '& .MuiInputLabel-root': {
                        fontSize: 14,
                    },
                    '& .MuiInputLabel-shrink': {
                        marginTop: '-7px',
                        marginLeft: '-13px',
                        fontSize: 16,
                        color: 'black'
                    },
                    '& .MuiFormLabel-root': {
                        color: '#a6afb7',
                        lineHeight: 0.5,
                    }
                }
            }
        },
    });

const useStyles2 = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            flexGrow: 1,
        },
        paper: {
            padding: theme.spacing(2),
            margin: 'auto',
            // maxWidth: 500,
        },
        image: {
            width: 350,
            height: 350,
        },
        img: {
            margin: 'auto',
            display: 'block',
            maxWidth: '100%',
            maxHeight: '100%',
        },
    }),
);

const Profile = (props) => {

    const useStyles = makeStyles((theme: Theme) =>
        createStyles({
            root: {
                maxWidth: '100%',
                display: 'flex',
            },
            tabs: {
                backgroundColor: '',
                boxShadow: 'none'
            },
            // c,over: {
            //     flex: '1 0 auto',
            //     width: 151,
            //     paddingTop: '70.25%'
            // },
            content: {
            },
            media: {
                height: 0,
                paddingTop: '70.25%', // 16:9
            },
            expand: {
                transform: 'rotate(0deg)',
                marginLeft: 'auto',
                transition: theme.transitions.create('transform', {
                    duration: theme.transitions.duration.shortest,
                }),
            },
            expandOpen: {
                transform: 'rotate(180deg)',
            },
            small: {
                width: theme.spacing(3),
                height: theme.spacing(3),
            },
            avatar: {
                backgroundColor: red[500],
            },
            avatar2: {
                height: '95%',
                width: '87%',
                marginLeft: '5px'
            },
            popover: {
                pointerEvents: 'none',
            },
            paper: {
                width: '300px',
                height: '90px',
                backgroundColor: props.theme === 'white' ? '' : props.theme === 'dark' ? 'black' : 'purlpe',
                zIndex: 90,
                // boxShadow: 'none',
                border: '1px solid #E8E8E8'
            },
            paper2: {
                width: '0px',
                height: '0px',
                backgroundColor: 'transparent !important',
                boxShadow: 'none',
            },
            paper3: {
                width: '80px',
                height: '120px',
                boxShadow: 'none',
                backgroundColor: 'transparent'
            },
            offerSelf: {
                width: 'auto',
                // backgroundImage: 'linear-gradient(to right, #ef87be, #ffcee6)',
                float: 'right',
                maxWidth: '90%',
                padding: '5px 20px',
                borderRadius: '30px',
                backgroundColor: '#cbe4f9',
                maxHeight: '350px'
            },
            offerOther: {
                width: 'auto',
                // backgroundImage: 'linear-gradient(to right, #ef87be, #ffcee6)',
                float: 'left',
                maxWidth: '90%',
                padding: '5px 20px',
                borderRadius: '30px',
                backgroundColor: '#f9d8d6',
                maxHeight: '350px'
            },
            fulldiv: {
                width: '100%',
                backgroundColor: '',
                float: 'left',
                marginTop: '5px',
                height: "auto",
                maxHeight: '350px'
            },
        }),
    );

    const history = useHistory();
    // const location = useLocation();
    const [sendingdata, setSendingdata] = React.useState('');
    // const [prop, setprop] = React.useState();
    const [tt, settt] = React.useState('');
    const [open, setOpen] = React.useState(false);
    // console.log(props)
    var con;
    if (props) {
        // console.log('yes location')
        // console.log(props);
        // console.log(props.match.params);
        if (props.match.params != null) {
            if (props.match.params.id) {
                // console.log('c')
                con = props.match.params.id
                console.log(con)
            }
            else {
                // history.push({
                //     pathname: 'home',
                //     state: {
                //         "token": 1,
                //         "type": "error",
                //         "message": 'Something went wrong'
                //     }
                // })

            }
        }
        else {
            // history.push({
            //     pathname: 'home',
            //     state: {
            //         "token": 1,
            //         "type": "error",
            //         "message": 'Something went wrong'
            //     }
            // })
        }

    }
    else {
        // console.log('nope')
    }
    // console.log(con)

    const classes = useStyles();
    var curdate = new Date()
    curdate = moment(curdate).format('YYYY-MM-DD')
    const classes2 = useStyles2();
    const [bgImage, setbgImage] = React.useState(logo);
    const [event, setevent] = React.useState({'title': 'Loading'});
    const [media, setmedia] = React.useState(false);
    const [noposter, setnoposter] = React.useState(false);
    const [userreg, setuserreg] = React.useState(false);
    const commentinput = React.useRef()
    const [comments, setcomments] = React.useState(false);
    const [allcomments, setallcomments] = React.useState([]);
    const [registrations, setregistrations] = React.useState([]);
    // const [aname, setaname] = React.useState(false);
    // const [file, setfile] = React.useState(false);
    // const [deleve, setdeleve] = React.useState(false);
    const [loading, setloading] = React.useState(true);
    const [editcontent, seteditcontent] = React.useState('Add');
    const [dcontent, setdcontent] = React.useState(false);
    const [editcontent2, seteditcontent2] = React.useState('Add');
    const [dcontent2, setdcontent2] = React.useState(false);
    const [afile, setafile] = React.useState();
    const [markas, setmarkas] = React.useState(false);
    // const [proimage, setpro] = React.useState();
    const hiddenFileInput = React.useRef(null);
    const [filename, setfilename] = React.useState('Choose a file');
    // const [emailtool, setemailtool] = React.useState(false);
    // const [emailsel, setemailsel] = React.useState('Click to Copy Email');
    const [incomment, setincomment] = React.useState('');
    const [register, setregister] = React.useState(false);
    const [regs, setregs] = React.useState(false);
    const [addReport, setaddReport] = React.useState(false);
    const [getreport, setgetreport] = React.useState({});
    const [report, setreport] = React.useState({})
    // const [deleteloading, setdeleteloading] = React.useState('Delete');
    // const [deletedisabling, setdeletedisabling] = React.useState(false);
    const [registerloading, setregisterloading] = React.useState('Register');
    const [registerdisabling, setregisterdisabling] = React.useState(false);
    const [commentsloading, setcommentsloading] = React.useState(false);
    const [regdetails, setregdetails] = React.useState({ 'name': '', 'reason': '' });
    const fetchData = React.useCallback(() => {
        // console.log('fetching')
        if(con!== undefined){
            axios.get(process.env.REACT_APP_DOMAIN+"/details/event=" + con, { 'headers': { 'Authorization': 'Token ' + props.token } })
                .then((response) => {
                    // console.log(response.data)
                    // console.log(response.data.event)
                    // console.log('entered')
                    setevent(response.data)
                    document.title = response.data.title
                    if (response.data.poster != null) {
                        var phurl = process.env.REACT_APP_DOMAIN+'' + response.data.poster;
                        // console.log(phurl)
                        setbgImage(phurl);
                    }
                    else{
                        setbgImage(logo2);
                        setnoposter(true)
                    }
                })
                .catch((error) => {
                    setSendingdata('Something went wrong, Please Try Again')
                    settt('error')
                    setOpen(true);
                })
            // axios.get(process.env.REACT_APP_DOMAIN + "/profile/user=" + event.by.id, { 'headers': { 'Authorization': 'Token ' + props.token } })
            //     .then((response) => {
            //         // console.log(response.data)
            //         if (response.data.photo != null) {
            //             // console.log('present')
            //             if (response.data.photo.length > 1) {
            //                 // console.log('yes')
            //                 // console.log(process.env.REACT_APP_DOMAIN+'' + response.data.photo)
            //                 setpro(process.env.REACT_APP_DOMAIN + '' + response.data.photo)
            //                 // setyes(true)
            //             }
            //         }
            //         setaname(nb)
            //     })
            //     .catch((error) => {
            //         console.log(error)
            //         setSendingdata('Something went Wrong')
            //         settt('error')
            //         setOpen(true)
            //     })
            axios.get(process.env.REACT_APP_DOMAIN + "/comments/event=" + con, { 'headers': { 'Authorization': 'Token ' + props.token } })
                .then((response) => {
                    // console.log(response.data)
                    setallcomments(response.data)
                })
                .catch((error) => {
                    console.log(error)
                    setSendingdata('Something went Wrong')
                    settt('error')
                    setOpen(true)
                })
            axios.get(process.env.REACT_APP_DOMAIN + "/registrations/event=" + con, { 'headers': { 'Authorization': 'Token ' + props.token } })
                .then((response) => {
                    // console.log(response.data)
                    setregistrations(response.data)
                })
                .catch((error) => {
                    console.log(error)
                    setSendingdata('Something went Wrong')
                    settt('error')
                    setOpen(true)
                })
            axios.get(process.env.REACT_APP_DOMAIN + "/checkreport/event=" + con, { 'headers': { 'Authorization': 'Token ' + props.token } })
                .then((response) => {
                    // console.log(response.data)
                    if (response.data.status) {
                        // console.log('Not Found')
                    }
                    else {
                        setgetreport(response.data)
                    }
                })
                .catch((error) => {
                    console.log(error)
                    setSendingdata('Something went Wrong')
                    settt('error')
                    setOpen(true)
                })
            axios.get(process.env.REACT_APP_DOMAIN + "/registered="+con, { 'headers': { 'Authorization': 'Token ' + props.token } })
                .then((response) => {
                    // console.log(response.data)
                    setuserreg(response.data.reg)
                    setloading(false)
                })
                .catch((error) => {
                    console.log(error)
                    setSendingdata('Something went Wrong')
                    settt('error')
                    setOpen(true)
                })
        }
        
    }, [con,props.token])
    React.useEffect(() => {
        fetchData()
    }, [fetchData])


    const handleMedia = (event, img) => {
        // console.log(event)
        // console.log(img)
        // console.log('clicked')
        setmedia(true)
    };

    const CloseMedia = () => {
        setmedia(false)
    };

    const handleClose = (event, reason) => {
        setOpen(false);
    };
    // console.log(bgImage)


    const regdata = []
    if(registrations){
        registrations.map(function (responseDatab, index) {
            var pdate = moment(responseDatab.time, "HH:mm:ss").fromNow()
            regdata.push({
                TID: responseDatab.id,
                User: responseDatab.by.username,
                Name: responseDatab.name, Reason: responseDatab.reason, Registered: pdate,
                // Last: edate,
            })
            return (<div></div>)
        })
    }
    const [tab, settab] = React.useState(0);

    const handleChangeTab = (event, tab) => {
        settab(tab);
    };
    const columnsBuyer = [{ name: "TID", label: 'TID', options: { filter: true, filterType: 'multiselect', sort: true, } },
    { name: "User", label: "User", options: { filter: true, filterType: 'multiselect', sort: true, customBodyRender: (value) => (<Link to={'/main/profile/'+value}><p className={"colbody point underline-hover texts-" + props.theme}> {value} </p></Link>) } },
    { name: "Name", label: "Name", options: { filter: true, filterType: 'multiselect', sort: true, } },
    { name: "Reason", label: "Reason", options: { filter: true, filterType: 'multiselect', sort: true, } },
    { name: "Registered", label: "Registered", options: { filter: false, sort: true, } },
    ];

    const optionsBuyer = {
        filterType: 'checkbox',
        textLabels: {
            body: {
                noMatch: 'No Registrations yet',
            },
        },
        onRowsDelete: (rowsDeleted) => {
            // console.log(rowsDeleted.data)
            // setdel([])
            // delx = []
            // for (var i = 0; i < rowsDeleted.data.length; i++) {
            //     delx.push(dataBuyer2[rowsDeleted.data[i].index]['TID'])
            // }
            // console.log(delx)
            // setdel(delx)
            // setOpen2(true)
            // return false;
        },
        onDownload: (buildHead, buildBody, columns, data) => {
            for (var i = 0; i < data.length; i++) {
                // console.log(data[i])
                // console.log(data[i].data[1])
                data[i].data[1] = data[i].data[1][0]
                // data[i].data[3] = data[i].data[3][0]
                // data[i].data[4] = data[i].data[4][0]
                // data[i].data[7] = data[i].data[7][0]
            }
            return "\uFEFF" + buildHead(columns) + buildBody(data);
        },
        downloadOptions: {
            filename: 'registrations.csv',
            separator: ',',
            filterOpions: {
                useDisplayedColumnsOnly: true,
                useDisplayedRowsOnly: true,
            }
        },
        customSort: (data, colIndex, order, meta) => {
            if (colIndex === 1) {
                // console.log(colIndex)
                return data.sort((a, b) => {
                    return (a.data[colIndex][0] < b.data[colIndex][0] ? -1 : 1) * (order === 'desc' ? 1 : -1);
                });
            }
            else {
                return data.sort((a, b) => {
                    // console.log(a.data[colIndex])
                    return (a.data[colIndex] < b.data[colIndex] ? -1 : 1) * (order === 'desc' ? 1 : -1);
                });
            }
        },
        print: false,
        sortDescFirst: false,
        sortThirdClickReset: false,
        selectableRows: 'none',
    };



    // const copyToClipboard = (e) => {
    //     navigator.clipboard.writeText(e);
    //     setemailsel('Copied the Email')
    // };

    // const toggle = () => {
    //     setemailtool(!emailtool)
    // };


    const CloseMarkas = () => {
        setmarkas(false)
    };

    const CloseRegs = () => {
        setregs(false)
    };


    const CloseReport = () => {
        setaddReport(false)
    };

    const CloseComments = () => {
        setcomments(false)
    };

    const CloseRegister = () => {
        setregister(false)
    };

    // const closeFile = (event) => {
    //     setfile(false)

    // };
    // const handleMedia = (event, img) => {
    //     // console.log(event)
    //     // console.log(img)
    //     // console.log('clicked')
    //     setmedia(true)
    // };
    // const CloseMedia = () => {
    //     setmedia(false)
    // };


    const addComment = () => {
        setcommentsloading(true)
        if (incomment === undefined) {
            settt('error')
            setSendingdata('Please add Something')
            setOpen(true)
            setcommentsloading(false)
            return 0;
        }
        if (incomment.length < 1) {
            settt('error')
            setSendingdata('Please add Something')
            setOpen(true)
            setcommentsloading(false)
            return 0;
        }
        var inp = { 'comment': incomment }
        axios.post(process.env.REACT_APP_DOMAIN + '/addcomment/event=' + event.id, inp, { 'headers': { 'Authorization': 'Token ' + props.token } })
            .then((response) => {
                // console.log(response.data)
                setincomment('')
                setcommentsloading(false)
                fetchData()
                props.fetch()
            })
            .catch((error) => {
                console.log(error)
                setSendingdata('Something went wrong')
                settt('error')
                setOpen(true)
                setcommentsloading(false)
            })
    };


    const markEventAs = (par) => {
        // console.log(par)
        axios.get(process.env.REACT_APP_DOMAIN + '/mark-event=' + event.id + '/as=' + par, { 'headers': { 'Authorization': 'Token ' + props.token } })
            .then((response) => {
                // console.log(response.data)
                setmarkas(false)
                setSendingdata('Successfully Done')
                settt('success')
                setOpen(true)
                fetchData()
                props.fetch()
            })
            .catch((error) => {
                console.log(error)
                setSendingdata('Something went wrong')
                settt('error')
                setOpen(true)
            })
    };

    const Register = () => {
        setregisterloading(<CircularProgress size="20px" className={"textb-" + props.theme} />)
        setregisterdisabling(true)
        if (regdetails.name === undefined || regdetails.reason === undefined) {
            settt('error')
            setSendingdata('Please add details properly')
            setOpen(true)
            setregisterloading('Register')
            setregisterdisabling(false)
            return 0;
        }
        if (regdetails.name.length < 1 || regdetails.reason.length < 1) {
            settt('error')
            setSendingdata('Please add details properly')
            setOpen(true)
            setregisterloading('Register')
            setregisterdisabling(false)
            return 0;
        }
        var inp = { 'name': regdetails.name, 'reason': regdetails.reason }
        axios.post(process.env.REACT_APP_DOMAIN + '/register/event=' + event.id, inp, { 'headers': { 'Authorization': 'Token ' + props.token } })
            .then((response) => {
                // console.log(response.data)
                setregdetails({ 'name': '', 'reason': '' })
                setregister(false)
                setregisterloading('Register')
                setregisterdisabling(false)
                fetchData()
                props.fetch()
            })
            .catch((error) => {
                console.log(error)
                setSendingdata('Something went wrong')
                settt('error')
                setregisterloading('Register')
                setregisterdisabling(false)
                setOpen(true)
            })
    };
    const handleExpandClick = () => {
        setcomments(true);
        // commentinput.focus()
    };
    const openRegs = () => {
        setregs(true);
        // commentinput.focus()
    };
    const openRegister = () => {
        setregister(true);
        // commentinput.focus()
    };
    const handleKeypress = e => {
        //it triggers by pressing the enter key
        if (e.keyCode === 13) {
            addComment();
        }
    };


    const handleKeypressReg = e => {
        //it triggers by pressing the enter key
        if (e.keyCode === 13) {
            Register();
        }
    };

    // const goto = () => {
    //     /* Get the text field */
    //     var copytext = event.mlink;
    //     // console.log(copytext)
    //     if (copytext != null) {
    //         window.open(copytext);
    //     }

    // }

    const handleUpload = () => {
        // console.log('entered')
        hiddenFileInput.current.click()
    };

    const handleChangeU = (event) => {
        setreport({ ...report, [event.target.name]: event.target.files[0] })
        // console.log(event.target.files)
        setafile(URL.createObjectURL(event.target.files[0]))
        setfilename(event.target.files[0].name)
        // console.log(change)
    };

    const handleChangeEdit = () => {
        if (editcontent === 'Add') {
            seteditcontent(<CircularProgress size="20px" className={"textb-" + props.theme} />)
            // setdcontent(true)
            // console.log(change)
            let formdata = new FormData();
            // console.log(formdata)
            if (report.file === undefined) {
                setSendingdata('Please add file')
                settt('error')
                setOpen(true)
                seteditcontent('Add')
                setdcontent(false)
                return 0;
            }
            else {
                formdata.append('file', report.file, filename)
            }
            // console.log(formdata)
            // for (var pair of formdata.entries()) {
            //     console.log(pair[0] + ', ' + pair[1]);
            // }
            // console.log(formdata)
            axios.post(process.env.REACT_APP_DOMAIN + '/addreportfile/event=' + event.id, formdata, { 'headers': { 'Authorization': 'Token ' + props.token, 'Content-type': 'multipart/form-data' } })
                .then((response) => {
                    // console.log(response.data)
                    setaddReport(false)
                    setSendingdata('Adding Report was Successful')
                    settt('success')
                    setOpen(true)
                    seteditcontent('Add')
                    setdcontent(false)
                    fetchData()
                    props.fetch()
                })
                .catch((error) => {
                    console.log(error)
                    setOpen(true)
                    setSendingdata('Something went wrong')
                    settt('error')
                    seteditcontent('Add')
                    setdcontent(false)
                })
        }
        else {
            seteditcontent('Add')
            setdcontent(false)
        }
    };


    const handleChangeEdit2 = () => {
        if (editcontent2 === 'Add') {
            seteditcontent2(<CircularProgress size="20px" className={"textb-" + props.theme} />)
            // setdcontent(true)
            // console.log(change)
            if (report.title === undefined || report.body === undefined) {
                setSendingdata('Please add Main Details Properly')
                settt('error')
                setOpen(true)
                seteditcontent2('Add')
                setdcontent2(false)
                return 0;
            }
            // console.log(formdata)
            axios.post(process.env.REACT_APP_DOMAIN + '/addreportformat/event=' + event.id, report, { 'headers': { 'Authorization': 'Token ' + props.token } })
                .then((response) => {
                    // console.log(response.data)
                    setaddReport(false)
                    setSendingdata('Adding Report was Successful')
                    settt('success')
                    setOpen(true)
                    seteditcontent2('Add')
                    setdcontent2(false)
                    fetchData()
                    props.fetch()
                })
                .catch((error) => {
                    console.log(error)
                    seteditcontent2('Add')
                    setdcontent2(false)
                    setOpen(true)
                    setSendingdata('Something went wrong')
                    settt('error')
                })
        }
        else {
            seteditcontent2('Add')
            setdcontent2(false)
        }
    };
    const downloadreport = () => {
        // console.log(getreport)
        // console.log(getreport.file)
        if (getreport.file === null) {
            var doc = new jsPDF('p', 'in', 'letter');

            doc.addImage(k1, 'PNG', 0.4, 0.2, 1, 1);
            doc.addImage(k3, 'PNG', 1.4, 0.2, 5, 1);
            doc.setFontSize(17);
            // // doc.addFont('arial', 'Arial', 'normal',)
            // doc.addFont('Roboto-Light', 'Roboto-Light', 'normal');
            // doc.addFont('Roboto-Thin', 'Roboto-Thin', 'normal');
            // doc.addFont('WeezerFont', 'WeezerFont', 'normal');
            // doc.addFont('Nuc', 'Nuc', 'normal');
            // doc.setFont('helvetica', 'bold');
            // // doc.text("Saraf Circle", 0.5, 1.3);
            // doc.setFont('Roboto-Thin', 'normal');
            doc.setFont('times', 'italic');
            doc.setLineWidth(0.1);
            doc.setDrawColor(232, 232, 232);
            doc.rect(0.4, 1.7, 7.7, 0.05);//horizontal line
            doc.rect(8.1, 1.7, 0.05, 5.3);//vertical line
            doc.setFontSize(13);
            doc.text('Report of ' + event.etype + ' : ' + event.title + ' on ' + moment(event.date).format("Do MMMM YYYY") + ' ' + event.tfrom, 0.4, 2.2);
            // doc.setDrawColor(150, 150, 150);
            doc.setLineWidth(0.03);
            doc.setFontSize(13);
            // doc.text('Date: ' + event.date + ', Time: ' + event.tfrom + '-' + event.tto, 6.6, 2.2);

            doc.setFont('times', 'normal');
            doc.text(0.4, 2.5, getreport.title)
            var lines = doc.splitTextToSize(getreport.body, 8.1)
            // var y;
            doc.text(0.4, 3.0, lines)
            doc.setLineWidth(0.03);
            if (getreport.objectives) {
                doc.setFont('times', 'bold');
                doc.text('Objectives: ', 0.4, 3.5);
                doc.setFont('times', 'normal');
                var lines2 = doc.splitTextToSize(getreport.objectives, 8.1)

                doc.text(0.4, 3.7, lines2)

            }
            else {
            }
            if (getreport.keypoints) {
                doc.setFont('times', 'bold');
                doc.text('Key Points: ', 0.5, 4.5);
                doc.setFont('times', 'normal');
                var lines3 = doc.splitTextToSize(getreport.keypoints, 8.1)

                doc.text(0.4, 4.6, lines3)
            }
            if (getreport.outcomes) {
                doc.setFont('times', 'bold');
                doc.text('Outcomes: ', 0.5, 5.5);
                doc.setFont('times', 'normal');
                var lines4 = doc.splitTextToSize(getreport.outcomes, 8.1)

                doc.text(0.4, 5.6, lines4)
            }
            if (getreport.feedback) {
                doc.setFont('times', 'bold');
                doc.text('Feedback: ', 0.5, 6.5);
                doc.setFont('times', 'normal');
                var lines5 = doc.splitTextToSize(getreport.feedback, 8.1)

                doc.text(0.4, 6.6, lines5)
            }
            // doc.setDrawColor(232, 232, 232);
            // doc.rect(0.4, 1.6, 6, 6);
            // if (event.poster) {
            //     doc.addImage(event.poster, 'JPG', 0.4, 1.6, 6, 6);
            // }
            // else {
            //     doc.addImage(logo1, 'JPG', 0.4, 1.6, 6, 6);
            // }

            doc.save('Report.pdf');
        }
        else {
            var a = document.createElement("a");
            // console.log(process.env.REACT_APP_DOMAIN+'' + getreport.file)
            a.href = process.env.REACT_APP_DOMAIN + '' + getreport.file
            a.target = '_blank'
            a.setAttribute("download", 'Report.pdf');
            a.click();
        }
        // console.log(Object.keys(getreport))
    }

    return (
        <>
            <UserHeader id={props.username} />
            {/* Page content */}
            <Container className="mt--6" fluid>
                <Row>
                    <Helmet>
                        <meta charSet="utf-8" />
                        <meta name="theme-color" content="#ffffff" />
                        <meta name="description" content={event.description}/>
                        <meta property="og:description" content={event.description}/>
                        <meta property="og:title" content='DepAct' />
                        <meta property="og:type" content="Event" />
                        <meta property="og:url" content={"https://depact-kjsieit.vercel.app/event/"+event.id} />
                    </Helmet>
                    <Col className="order-xl-1" xl="12">
                        <Row className="justify-content-left text-right bg-yellowc">
                            {/* <Col className="order-lg-2 mt--3 bg-greenc" lg="9" md="6" sm="6" xs="6" >
                            </Col> */}
                            <Col className="order-lg-2 mt--3 bg-pinkc" lg="3" md="6" sm="6" xs="6" >
                                <div className="card-profile-image" style={{ zIndex: 9 }} onClick={(event) => (noposter? console.log('haha') :handleMedia(event, bgImage))}>
                                </div>
                            </Col>
                        </Row>
                        <Card className={"shadow cardbg-" + props.theme}>
                            <CardHeader style={{paddingTop: '20px',wordWrap: 'break-word',wordBreak: ''}} className={"border-0 cardbg-" + props.theme}>
                                {(loading ?
                                    <CircularProgress size="40px" />
                                :
                                <Row className="align-items-center">
                                        <Col xs="12" sm="12" md="12" lg="4" xl="4" className="bg-cyanc text-left" >

                                            <img
                                                alt="..."
                                                style={{ zIndex: 9, maxWidth: '200px' }}
                                                className={(noposter ? "rounded-circlec noshad" : "rounded-circlec noshad point")}
                                                src={bgImage}
                                                onError={(e) => { e.target.src = 'https://i.ibb.co/drffP5L/place.png' }}
                                            /></Col>
                                        <Col xs="12" sm="12" md="12" lg="8" xl="8" className="bg-cyanc text-left" >
                                        <h1 className="no-w sbys-h" style={{fontWeight: 'normal'}}>{event.title} [ {event.etype} ]</h1>
                                        <div className="sbys">
                                                <h3 className="mb-0 no-w sbys-h" style={{ fontWeight: 'normal' }}>{moment(event.date).format('Do MMM YY')}, <h4 className="no-w sbys-h">{moment(event.tfrom, "HH:mm:ss").format("hh:mm A")} - {moment(event.tto, "HH:mm:ss").format("hh:mm A")}</h4></h3>
                                        </div>
                                        <h3 className="no-w">For {event.target} ( {event.status} )</h3>
                                        <h3 className="no-w">Presenter:  {event.presenter} {(event.presenterd ? ', ' + event.presenterd : null)}{(event.presenterc ? ', ' + event.presenterc : null)}</h3>
                                        {(event.perks ?
                                                    <p>{event.perks}</p>
                                            :
                                            null
                                        )}
                                        {(event.description ?
                                                    <p>{event.description}</p>
                                            :
                                            null
                                        )}
                                        {(event.regfrom ?
                                            <Col lg="4" xl="3" sm="12" md="12">
                                                <FormGroup>
                                                    <label className="form-control-label" htmlFor="input-username"></label>
                                                    <p>Registrations from {event.regfrom} to {event.regto}
                                                        {(event.rlink ? <a className="ml-2" href={event.rlink} >Register</a> : null)}
                                                        {(event.mlink ? <a className="ml-2" href={event.mlink} >Go to Meeting</a> : null)}
                                                    </p>
                                                </FormGroup>
                                            </Col>
                                            :
                                            null
                                        )}
                                        {(event.by === undefined ?
                                            null
                                            :
                                            <p >Publisher: <Link className="point underline-hover" to={'/main/profile/'+event.by.username}> {event.by.username}</Link></p>
                                        )}
                                        {(event.tags ?
                                            (event.tags.length > 0 ?
                                                    <div>
                                                        <label className="form-control-label" htmlFor="input-username">Tags</label>
                                                        {event.tags.map((tag, index) => (
                                                            <Link to={'/main/profile/'+tag.username}><Chip className="ml-1 point" label={tag.username} /></Link>
                                                        ))}
                                                    </div>
                                                :
                                                null
                                            )
                                            :
                                            null
                                        )}
                                    </Col>
                                    <Col className="text-right bg-teal" xs="4">
                                    </Col>
                                </Row>
                                
                                )}
                            </CardHeader>
                            <CardBody className={"cardbg-" + props.theme}>
                                {(loading ?
                                    null
                                    :
                                <Form>
                                    <hr className="my-4 mt-0" />
                                    <h6 className="heading-small text-muted mb-4 mt-3">Organizer Details</h6>


                                    <div className="">
                                        <Row className="pt-3">

                                            {(event.organizer ?
                                                (event.organizer.length > 1 ?
                                                    <Col lg="4" xl="3" sm="12" md="12">
                                                        <FormGroup>
                                                            <label className="form-control-label" htmlFor="input-username">Organizer</label>
                                                            <p>{event.organizer}</p>
                                                        </FormGroup>
                                                    </Col>
                                                    :
                                                    null
                                                )
                                                :
                                                null
                                            )}
                                            {(event.teacher1 ?
                                                <Col lg="8" xl="9" sm="12" md="12">
                                                    <FormGroup>
                                                        <label className="form-control-label" htmlFor="input-username">Faculty Co-ordinators</label>
                                                        <p>{event.teacher1}{(event.teacher2 ? ', ' + event.teacher2 : null)}{(event.teacher3 ? ', ' + event.teacher3 : null)}</p>
                                                    </FormGroup>
                                                </Col>
                                                :
                                                null
                                            )}
                                            {(event.convener1 ?
                                                <Col lg="8" xl="9" sm="12" md="12">
                                                    <FormGroup>
                                                        <label className="form-control-label" htmlFor="input-username">Conveners</label>
                                                        <p>{event.convener1}{(event.convener2 ? ', ' + event.convener2 : null)}</p>
                                                    </FormGroup>
                                                </Col>
                                                :
                                                null
                                            )}
                                            {(event.student1 ?
                                                <Col lg="8" xl="9" sm="12" md="12">
                                                    <FormGroup>
                                                        <label className="form-control-label" htmlFor="input-username">Student Co-ordinators</label>
                                                        <p>{event.student1}{(event.student2 ? ', ' + event.student2 : null)}</p>
                                                    </FormGroup>
                                                </Col>
                                                :
                                                null
                                            )}
                                        </Row>
                                    </div>
                                </Form>
                                )}
                            </CardBody>
                            <CardFooter className={"cardbg-" + props.theme}>
                                <div className="text-center">
                                    {/* <Button color="danger" outline onClick={handleChangeEdit}>
                                        {editcontent === 'Report' ?
                                        <WarningIcon className="mr-1 " style={{ width: 18 }}/>
                                        :
                                        <div></div>
                                        }
                                        {editcontent}
                                    </Button> */}
                                    {(props.adminValue ? 

                                        (event.rlink ?
                                            null
                                            :
                                            <Button color="" onClick={openRegs}>
                                                Registrations
                                            </Button>
                                                   
                                        )
                                        :
                                        (event.rlink ?
                                                <Button onClick={() => window.open(event.rlink)} className="text-left p-2 pl-3" style={{ width: '100%' }} color="">
                                                    <p className={"m-0 textsp-" + props.theme}>Register</p>
                                                </Button>
                                            :
                                            (userreg ?
                                                    <Button onClick={openRegister} className="text-left p-2 pl-3" style={{ width: '100%' }} color="">
                                                        <p className={"m-0 textsp-" + props.theme} disabled={registerdisabling} >{registerloading}</p>
                                                    </Button>
                                                :
                                                null
                                            )
                                        )
                                    )}
                                    {(props.adminValue ?

                                        (curdate > event.date ?
                                            (Object.keys(getreport).length > 1 ?
                                                <Button color="" outline onClick={downloadreport}>
                                                            Get Report
                                                </Button>
                                                :
                                                <Button color="" outline  onClick={() => setaddReport(true)}>
                                                            Add Report
                                                </Button>
                                            )
                                            : 
                                            (props.superValue && event.by.id === props.username ?

                                                <Button color="" outline onClick={() => setmarkas(true)}>
                                                    Mark As
                                                </Button>
                                                :
                                                null
                                            )
                                                
                                        )
                                        :
                                        null
                                    )}
                                    <Button color="" outline onClick={handleExpandClick}>
                                        Comments
                                        </Button>
                                </div>
                            </CardFooter>
                        </Card>
                    </Col>
                </Row>
                <Modal
                    size="lg"
                    className={"modal-dialog-centered pl-4 pr-4 pt-4 pb-4 cv-"+props.theme}
                    isOpen={comments}
                    toggle={CloseComments}>
                    <Card className={'cardbg-'+props.theme} elevation={0} >
                        <CardHeader style={{backgroundColor: 'transparent'}}>{event.title + ' Comments'} </CardHeader>
                        <div style={{ padding: 0 }} >
                            <div id="mainComments" style={{ minHeight: '400px', maxHeight: '400px', minWidth: '300px', backgroundColor: '', padding: '10px', overflowY: 'scroll' }}>
                                {(allcomments === undefined ?
                                    <div>Select a chat</div>
                                    :
                                    allcomments.map(function (resp, index) {
                                        if (resp.by !== undefined) {
                                            if (resp.by.id === props.username) {
                                                return (
                                                    // <div className="fulld"><p className="mt-0 mb-0 ml-0 mr-0 message">{resp.message}</p></div>
                                                    <div className={classes.fulldiv}>
                                                        <div className={classes.offerSelf}>
                                                            <div style={{ display: 'inline-block' }} className="point">
                                                                <Avatar className={classes.small} style={{ float: 'left' }} src={process.env.REACT_APP_DOMAIN + '' + resp.by.photo}>{resp.by.username.substring(0, 1)}</Avatar>
                                                                <p style={{ float: 'left' }} className="m-0 ml-2 point">You</p>
                                                            </div>
                                                            <div className={classes.cond}><p className={classes.condt}>{resp.body}</p></div>
                                                        </div>
                                                    </div>
                                                )
                                            }
                                            else {
                                                return (
                                                    // <div className="fulld"><p className="mt-0 mb-0 ml-0 mr-0 message">{resp.message}</p></div>
                                                    <div className={classes.fulldiv}>
                                                        <div className={classes.offerOther}>
                                                            <div style={{ display: 'inline-block' }} className="point" onClick={() => history.push({ pathname: 'view-profile', state: { "id": resp.by.id } })}>
                                                                <Avatar className={classes.small} style={{ float: 'left' }} src={process.env.REACT_APP_DOMAIN + '' + resp.by.photo}>{resp.by.username.substring(0, 1)}</Avatar>
                                                                <p style={{ float: 'left' }} className="m-0 ml-2 point">{resp.by.username}</p>
                                                            </div>
                                                            <div className={classes.cond}><p className={classes.condt}>{resp.body}</p></div>
                                                        </div>
                                                    </div>
                                                )
                                            }
                                        }
                                        return(null)
                                    })
                                )}
                                {commentsloading &&
                                    <div className={classes.fulldiv}>
                                        < div className={classes.offerSelf} >
                                            <Row>
                                                <Col>
                                                    <div style={{ display: 'inline-block', minWidth: '85px', float: 'left', backgroundColor: '' }} className="point">
                                                        <Avatar className={classes.small} style={{ float: 'left' }} src={process.env.REACT_APP_DOMAIN + '' + event.by.photo}>{'l'}</Avatar>
                                                        <p style={{ float: 'left' }} className="m-0 ml-2 point">You</p>
                                                    </div>
                                                    <div className={classes.cond}><p className={classes.condt}>{incomment}</p></div>
                                                </Col>
                                                <Col style={{ verticalAlign: 'middle', backgroundColor: '' }} ><CircularProgress className={"textb-" + props.theme} size="25px" /></Col>
                                            </Row>

                                        </div >
                                    </div >
                                }
                            </div>
                        </div>
                        <CardFooter style={{ backgroundColor: 'transparent' }}>
                            <Row>
                                <Col lg="10" md="10" sm="10" xs="10" >
                                    <Input placeholder="Add a Comment" value={incomment} className={'inputbg-'+props.theme} onChange={(e) => setincomment(e.target.value)} ref={commentinput} onKeyDown={handleKeypress} />
                                </Col>
                                <Col lg="2" md="2" sm="2" xs="2" >
                                    <Button outline onClick={addComment} >Go</Button>
                                </Col>
                            </Row>
                        </CardFooter>
                    </Card>
                </Modal>
                <Modal
                    size="lg"
                    className="modal-dialog-centered pl-4 pr-4 pt-4 pb-4"
                    isOpen={regs}
                    toggle={CloseRegs}>
                    <div style={{ backgroundColor: '', padding: '10px', overflowY: '' }}>
                        {(registrations === undefined ?
                            <div>Something went wrong</div>
                            :
                            <MUIDataTable
                                className={"back noshad sbg-" + props.theme}
                                title={<div className="mt-4 mb-3" style={{ width: '100%', backgroundColor: '' }}><div className="col pl-0">
                                    <h6 className="text-uppercase ls-1 mb-1">
                                        {event.name}
                                    </h6>
                                    <h2 className="text-whiteg mb-0">Registrations</h2>
                                </div></div>}
                                data={regdata}
                                columns={columnsBuyer}
                                options={optionsBuyer}
                            />
                        )}
                    </div>
                </Modal>
                <Modal
                    size="lg"
                    className="modal-dialog-centered pl-4 pr-4 pt-4 pb-4"
                    isOpen={addReport}
                    toggle={CloseReport}>
                    <div style={{ backgroundColor: '', padding: '10px', overflowY: '' }}>
                        <Card elevation={0} >
                            <CardHeader>{'Add Report'}</CardHeader>
                            <Paper className={classes.tabs}>
                                <Tabs value={tab} onChange={handleChangeTab} indicatorColor="primary" textColor="primary" className="full-width" centered variant='outlined' >
                                    <Tab disableRipple className="half-width" label="Upload" />
                                    <Tab disableRipple className="half-width" label="Custom" />
                                </Tabs>
                            </Paper>
                            {tab === 0 &&
                                <div style={{ minHeight: '500px' }} className="pl-3 pr-3 mt-3 ">

                                    <h6 className="heading-small text-muted mb-4">Choose a file for Report</h6>


                                    <div className="">
                                        <Row className="pt-3">
                                            <Col lg="4" xl="4" sm="12" md="12" className="justify-content-center text-center">
                                                <FormGroup>
                                                    <Input className={"text-left form-control-alternative inputbg-" + props.theme} onClick={handleUpload} id="input-cno" value={"File : " + filename} placeholder="Event Poster" type="button" />
                                                    <input id="contained-button-file" name="file" onChange={handleChangeU} type="file" ref={hiddenFileInput} style={{ display: 'none' }} />
                                                </FormGroup>
                                            </Col>
                                            <Col lg="8" xl="8" sm="12" md="12" className="justify-content-center text-center">
                                                <FormGroup>
                                                    {(afile === undefined ?
                                                        <div className={'inputbg-' + props.theme} style={{ height: '300px', width: '300px' }}></div>
                                                        :
                                                        <div className={'inputbg-' + props.theme} style={{ height: '300px', width: '300px' }}></div>

                                                    )}
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </div>
                                    <div className="text-center mt-3">
                                        <Button
                                            color="info"
                                            outline
                                            disabled={dcontent}
                                            onClick={handleChangeEdit}
                                        >
                                            {editcontent}
                                        </Button>
                                    </div>
                                </div>
                            }
                            {tab === 1 &&
                                <div style={{ minHeight: '500px' }} className="pl-3 pr-3 mt-3 ">

                                    <h6 className="heading-small text-muted mb-4">Add Report Details</h6>


                                    <div className="">
                                        <Row className="pt-3">
                                            <Col lg="6" xl="6" sm="12" md="12" className="justify-content-center mt-2 text-center">
                                                <FormGroup>
                                                    <MuiThemeProvider theme={getMuiTheme()}>
                                                        <TextField variant="outlined" className={"inputbg-" + props.theme} label="Title of Report" name="title" onChange={(e) => setreport({ ...report, [e.target.name]: e.target.value })}
                                                            InputProps={{
                                                                classes: {
                                                                    input: (props.theme === 'white' ? classes2.white : classes2.dark),
                                                                },
                                                            }} />
                                                    </MuiThemeProvider>
                                                </FormGroup>
                                            </Col>
                                            <Col lg="6" xl="6" sm="12" md="12" className="justify-content-center mt-2 text-center">
                                                <FormGroup>
                                                    <MuiThemeProvider theme={getMuiTheme()}>
                                                        <TextField variant="outlined" className={"inputbg-" + props.theme} label="Body" name="body" onChange={(e) => setreport({ ...report, [e.target.name]: e.target.value })}
                                                            InputProps={{
                                                                classes: {
                                                                    input: (props.theme === 'white' ? classes2.white : classes2.dark),
                                                                },
                                                            }} />
                                                    </MuiThemeProvider>
                                                </FormGroup>
                                            </Col>
                                            <Col lg="6" xl="6" sm="12" md="12" className="justify-content-center mt-4 text-center">
                                                <FormGroup>
                                                    <MuiThemeProvider theme={getMuiTheme()}>
                                                        <TextField variant="outlined" className={"inputbg-" + props.theme} label="Objectives" name="objectives" onChange={(e) => setreport({ ...report, [e.target.name]: e.target.value })}
                                                            InputProps={{
                                                                classes: {
                                                                    input: (props.theme === 'white' ? classes2.white : classes2.dark),
                                                                },
                                                            }} />
                                                    </MuiThemeProvider>
                                                </FormGroup>
                                            </Col>
                                            <Col lg="6" xl="6" sm="12" md="12" className="justify-content-center mt-4 text-center">
                                                <FormGroup>
                                                    <MuiThemeProvider theme={getMuiTheme()}>
                                                        <TextField variant="outlined" className={"inputbg-" + props.theme} label="Keypoints" name="keypoints" onChange={(e) => setreport({ ...report, [e.target.name]: e.target.value })}
                                                            InputProps={{
                                                                classes: {
                                                                    input: (props.theme === 'white' ? classes2.white : classes2.dark),
                                                                },
                                                            }} />
                                                    </MuiThemeProvider>
                                                </FormGroup>
                                            </Col>
                                            <Col lg="6" xl="6" sm="12" md="12" className="justify-content-center mt-4 text-center">
                                                <FormGroup>
                                                    <MuiThemeProvider theme={getMuiTheme()}>
                                                        <TextField variant="outlined" className={"inputbg-" + props.theme} label="Outcomes" name="outcomes" onChange={(e) => setreport({ ...report, [e.target.name]: e.target.value })}
                                                            InputProps={{
                                                                classes: {
                                                                    input: (props.theme === 'white' ? classes2.white : classes2.dark),
                                                                },
                                                            }} />
                                                    </MuiThemeProvider>
                                                </FormGroup>
                                            </Col>
                                            <Col lg="6" xl="6" sm="12" md="12" className="justify-content-center mt-4 text-center">
                                                <FormGroup>
                                                    <MuiThemeProvider theme={getMuiTheme()}>
                                                        <TextField variant="outlined" className={"inputbg-" + props.theme} label="Feedback" name="feedback" onChange={(e) => setreport({ ...report, [e.target.name]: e.target.value })}
                                                            InputProps={{
                                                                classes: {
                                                                    input: (props.theme === 'white' ? classes2.white : classes2.dark),
                                                                },
                                                            }} />
                                                    </MuiThemeProvider>
                                                </FormGroup>
                                            </Col>
                                        </Row>
                                    </div>
                                    <div className="text-center mt-3">
                                        <Button
                                            color="info"
                                            outline
                                            disabled={dcontent2}
                                            onClick={handleChangeEdit2}
                                        >
                                            {editcontent2}
                                        </Button>
                                    </div>
                                </div>
                            }
                        </Card>
                    </div>
                </Modal>
                <Modal
                    className="modal-dialog-centered pl-4 pr-4 pt-4 pb-4"
                    isOpen={markas}
                    toggle={CloseMarkas}>
                    <div style={{ backgroundColor: '', width: '100%', padding: '10px', overflowY: '' }}>
                        {(event.status === 'Pending' ?
                            <div>
                                <Button onClick={() => markEventAs('Ongoing')} className="text-left" style={{ width: '100%' }} color="link" outline >
                                    <p className="text-dark m-0">Ongoing</p>
                                </Button>
                                <Button onClick={() => markEventAs('Confirmed')} className="text-left ml-0" style={{ width: '100%' }} color="link" outline >
                                    <p className="text-dark m-0">Confirmed</p>
                                </Button>
                                <Button onClick={() => markEventAs('Cancelled')} className="text-left ml-0" style={{ width: '100%' }} color="link" outline >
                                    <p className="text-dark m-0">Cancelled</p>
                                </Button>
                            </div>
                            :
                            (event.status === 'Ongoing' ?
                                <div>
                                    <Button onClick={() => markEventAs('Pending')} className="text-left" style={{ width: '100%' }} color="link" outline >
                                        <p className="text-dark m-0">Pending</p>
                                    </Button>
                                    <Button onClick={() => markEventAs('Confirmed')} className="text-left ml-0" style={{ width: '100%' }} color="link" outline >
                                        <p className="text-dark m-0">Confirmed</p>
                                    </Button>
                                    <Button onClick={() => markEventAs('Cancelled')} className="text-left ml-0" style={{ width: '100%' }} color="link" outline >
                                        <p className="text-dark m-0">Cancelled</p>
                                    </Button>
                                </div>
                                :
                                (event.status === 'Confirmed' ?
                                    <div>
                                        <Button onClick={() => markEventAs('Ongoing')} className="text-left" style={{ width: '100%' }} color="link" outline >
                                            <p className="text-dark m-0">Ongoing</p>
                                        </Button>
                                        <Button onClick={() => markEventAs('Pending')} className="text-left ml-0" style={{ width: '100%' }} color="link" outline >
                                            <p className="text-dark m-0">Pending</p>
                                        </Button>
                                        <Button onClick={() => markEventAs('Cancelled')} className="text-left ml-0" style={{ width: '100%' }} color="link" outline >
                                            <p className="text-dark m-0">Cancelled</p>
                                        </Button>
                                    </div>
                                    :
                                    null
                                )
                            )
                        )}
                    </div>
                </Modal>
                <Modal
                    size="lg"
                    className="modal-dialog-centered pl-4 pr-4 pt-4 pb-4"
                    isOpen={register}
                    toggle={CloseRegister}>
                    <Card square elevation={0} >
                        <CardHeader>{'Register for ' + event.title}</CardHeader>
                        <Row className="pt-3 justify-content-center">
                            <Col lg="8" xl="8" sm="12" md="12" className="mt-3" >
                                <FormGroup>
                                    <MuiThemeProvider theme={getMuiTheme()}>
                                        <TextField label="Your Full Name" variant="outlined" className={"inputbg-" + props.theme} value={regdetails.name} name="name" onChange={(e) => setregdetails({ ...regdetails, [e.target.name]: e.target.value })} autoComplete="off"
                                            InputProps={{
                                                classes: {
                                                    input: (props.theme === 'white' ? classes2.white : classes2.dark),
                                                },
                                            }} />
                                    </MuiThemeProvider>
                                </FormGroup>
                            </Col>
                            <Col lg="8" xl="8" sm="12" md="12" className="mt-4" >
                                <FormGroup>
                                    <MuiThemeProvider theme={getMuiTheme()}>
                                        <TextField variant="outlined" className={"inputbg-" + props.theme} label="Reason for Registration" value={regdetails.reason} name="reason" onChange={(e) => setregdetails({ ...regdetails, [e.target.name]: e.target.value })} onKeyDown={handleKeypressReg}
                                            InputProps={{
                                                classes: {
                                                    input: (props.theme === 'white' ? classes2.white : classes2.dark),
                                                },
                                            }} />
                                    </MuiThemeProvider>
                                </FormGroup>
                            </Col>
                            <Col lg="8" xl="8" sm="12" md="12" className="mt-3 mb-2" >
                                <FormGroup className="text-center" >
                                    <Button outline onClick={Register} >Register</Button>
                                </FormGroup>
                            </Col>
                        </Row>
                    </Card>

                </Modal>
                {media &&
                    <div className="text-center" onClick={CloseMedia} style={{ height: '100vh', width: '100vw', backgroundColor: 'black', position: 'fixed', top: 0, left: 0, zIndex: 10, opacity: '100%' }}>
                        <img alt="Event Poster" style={{ height: '100%', width: 'auto', opacity: '100%', zIndex: 11 }} src={bgImage} onError={(e)=>{e.target.src='https://i.ibb.co/drffP5L/place.png'}} />
                    </div>}
                <Snackbar anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }} open={open} autoHideDuration={6000} onClose={handleClose}>
                    <MuiAlert elevation={6} variant="filled" onClose={handleClose} severity={tt}>{sendingdata}</MuiAlert>
                </Snackbar>
            </Container>
        </>
    );
};


export const mapStateToProps = state => {
    // console.log("this is the state", state);
    return {
        adminValue: state.switchRoutes.admin,
        userValue: state.switchRoutes.user,
        superValue: state.switchRoutes.super,
        username: state.userName,
        fullname: state.tempUser,
        theme: state.theme,
        text: state.text,
        token: state.token,
    }
}

export default connect(mapStateToProps)(Profile);
